import { Close as CloseIcon } from '@mui/icons-material';
import {
  Drawer as MuiDrawer,
  Grid,
  IconButton,
  SxProps,
  Theme,
} from '@mui/material';
import React, { FC, PropsWithChildren, ReactNode } from 'react';

import { DrawerPaper, DrawerLayout, DrawerHeader, DrawerTitle, DrawerActions, DrawerContent } from './Drawer.styles';

export interface BhiDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title?: ReactNode;
  titleActions?: ReactNode;
  sx?: SxProps<Theme>;
}

export const BhiDrawer: FC<PropsWithChildren<BhiDrawerProps>> = (props) => {
  const { isOpen, onClose, title, titleActions, children, sx } = props;

  return (
    <MuiDrawer
      PaperProps={{ component: DrawerPaper, sx }}
      anchor="right"
      open={isOpen}
      onClose={onClose}
    >
      <DrawerLayout container>
        <Grid item>
          <DrawerHeader container spacing={2}>
            <Grid item>
              {!!title && (
                <DrawerTitle variant="subtitle1">
                  {title}
                </DrawerTitle>
              )}
            </Grid>

            <Grid item>
              <DrawerActions container spacing={1}>
                {!!titleActions && <Grid item>{titleActions}</Grid>}
                <Grid item>
                  <IconButton aria-label="Close" onClick={onClose}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </DrawerActions>
            </Grid>
          </DrawerHeader>
        </Grid>

        <DrawerContent item>
          {children}
        </DrawerContent>
      </DrawerLayout>
    </MuiDrawer>
  );
};

export { BhiDrawer as Drawer };
export type { BhiDrawerProps as DrawerProps };
